/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatDoctorPatientContainer.vue?vue&type=template&id=d341a3ec"
import script from "./ChatDoctorPatientContainer.vue?vue&type=script&lang=js"
export * from "./ChatDoctorPatientContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d341a3ec')) {
      api.createRecord('d341a3ec', component.options)
    } else {
      api.reload('d341a3ec', component.options)
    }
    module.hot.accept("./ChatDoctorPatientContainer.vue?vue&type=template&id=d341a3ec", function () {
      api.rerender('d341a3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatDoctorPatientContainer.vue"
export default component.exports